import type { ReactNode } from 'react';

/** Disables every native control inside it; `contents` keeps the fieldset out of the layout. */
export const DisabledFieldset = ({ disabled, children }: { disabled: boolean; children: ReactNode }) => (
  <fieldset className="contents" disabled={disabled}>
    {children}
  </fieldset>
);
DisabledFieldset.displayName = 'DisabledFieldset';
